module.exports = __webpack_public_path__ + "static/media/action.fbfdaba0.svg";